import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { toast } from 'sonner';

import type { GetReservationById } from '@virtual-care/client';
import { Button } from '@virtual-care/shadcn';
import { JoinMeetingButton, useCanJoinMeeting } from '@virtual-care/ui';

const minutesBefore = 15;

export function JoinButton({
  reservation,
}: {
  reservation: GetReservationById;
}) {
  if (reservation.user.userType === 'B2B') {
    return <CopyGuestLinkButton reservation={reservation} />;
  }
  return <NavigateToMeetingButton reservation={reservation} />;
}

function CopyGuestLinkButton({
  reservation,
}: {
  reservation: GetReservationById;
}) {
  const { t } = useTranslation();
  const guestLink = reservation.guestLink;
  return (
    <Button
      onClick={() => {
        if (!guestLink) return;
        navigator.clipboard
          .writeText(guestLink)
          .then(() => toast.success(t('appointments.detail.linkCopied')))
          .catch(() => toast.error(t('appointments.detail.copyFailed')));
      }}
      disabled={!guestLink}
    >
      {t('appointments.detail.copyLink')}
    </Button>
  );
}

function NavigateToMeetingButton({
  reservation,
}: {
  reservation: GetReservationById;
}) {
  const navigate = useNavigate();
  useCanJoinMeeting({
    scheduledDate: reservation.scheduledDate,
    minutesFrom: reservation.minutesFrom,
    timezone: reservation.timezone,
    minutesBefore,
  });

  return (
    <JoinMeetingButton
      minutesBefore={minutesBefore}
      canJoin={true}
      // FOR SAKE OF TESTING TURN THIS OFF BUT ENABLE ONCE WE GO LIVE
      // TODO: Discuss using feature flag assignemnt per user for this
      // canJoin={canJoin}
      onClick={() => {
        navigate(`/meeting/${reservation.id}`);
      }}
    />
  );
}
